// MITT
import mitt from 'mitt';
import { Emitter } from 'mitt';
// let typescript know to expect emitter on window
declare global {
  interface Window {
    emitter: Emitter;
  }
}
// important, try to use existing mitt instance in window before creating new one!
window.emitter = window.emitter || mitt();

// Import CSS first thing
import '@/assets/styles/vars.css';

// Import all vendor styles here to limit to .wdw-widgets scope
import '@/assets/styles/vendors.scss';

// Import custom CSS files
import '@/assets/styles/custom.scss';
// use global var wdwWidgetsLang, and tell TS that it may exist
declare global {
  let wdwWidgetsLang: string;
}

// register fontawesome icons
import { library } from '@fortawesome/fontawesome-svg-core';

// brand icons
import { faFacebookF, faWhatsapp, faXTwitter } from '@fortawesome/free-brands-svg-icons';

// solid icons
import {
  faFilter,
  faChevronUp,
  faChevronDown,
  faTrashAlt,
  faQuestionCircle,
  faPencilAlt,
  faDownload,
  faSignOutAlt,
  faSignInAlt,
  faUser,
  faMapMarkerAlt,
  faGlobe,
  faPaperclip,
  faShareAlt,
  faEnvelope,
  faShare,
  faStar,
  faStarHalfAlt,
  faLock,
  faUnlockAlt,
  faComments,
  faPlus,
  faMinus,
  faCircleChevronUp,
  faCircleChevronDown,
  faSearch,
  faLayerGroup,
  faCalendarDays,
  faCircleArrowRight,
  faUserPlus,
  faAngleRight,
  faAngleLeft,
  faArrowUpRightFromSquare,
  faVolumeUp,
  faRefresh,
  faUpRightFromSquare,
  faCoins,
  faOnion,
  faHeart,
  faSlash,
  faSlashForward,
} from '@fortawesome/pro-solid-svg-icons';

//regular icons
import { faComment, faThumbsUp, faThumbsDown, faChartBar } from '@fortawesome/pro-regular-svg-icons';
// example: library.add(faPhone);
// use in component: <font-awesome-icon icon="phone" />
// eslint-disable-next-line
//@ts-ignore
library.add(
  faFilter,
  faChevronUp,
  faChevronDown,
  faTrashAlt,
  faQuestionCircle,
  faPencilAlt,
  faDownload,
  faComment,
  faSignOutAlt,
  faSignInAlt,
  faUser,
  faMapMarkerAlt,
  faGlobe,
  faPaperclip,
  faThumbsUp,
  faThumbsDown,
  faChartBar,
  faShareAlt,
  faFacebookF,
  faXTwitter,
  faWhatsapp,
  faEnvelope,
  faShare,
  faStar,
  faStarHalfAlt,
  faUnlockAlt,
  faLock,
  faComments,
  faPlus,
  faMinus,
  faCircleChevronUp,
  faCircleChevronDown,
  faSearch,
  faLayerGroup,
  faCalendarDays,
  faCircleArrowRight,
  faUserPlus,
  faAngleRight,
  faAngleLeft,
  faArrowUpRightFromSquare,
  faVolumeUp,
  faRefresh,
  faUpRightFromSquare,
  faCoins,
  faOnion,
  faHeart,
  faSlashForward
);

// define Validation rules
import { defineRule } from 'vee-validate';
import { required, email, numeric } from '@vee-validate/rules';

defineRule('required', required);
defineRule('email', email);
defineRule('numeric', numeric);
// defineRule('url', url);

// // vue-i18n
// // TODO - implement details, maybe other init is required
// // https://vue-i18n.intlify.dev/guide/advanced/lazy.html
// import { nextTick } from 'vue';
// import { createI18n } from 'vue-i18n';
// export const SUPPORT_LOCALES = ['de', 'de-idea', 'de-vorhaben'];
// export function setI18nLanguage(i18n: any, locale: string) {
//     if (i18n.mode === 'legacy') {
//       i18n.global.locale = locale
//     } else {
//       i18n.global.locale.value = locale
//     }
//     /**
//      * NOTE:
//      * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
//      * The following is an example for axios.
//      *
//      * axios.defaults.headers.common['Accept-Language'] = locale
//      */
//     //document.querySelector('html').setAttribute('lang', locale)
// }
// export function setupI18n(options = { locale: 'de', fallbackLocale: 'de', }) {
//     const i18n = createI18n(options);
//     setI18nLanguage(i18n, options.locale);
//     return i18n;
// }
// export async function loadLocaleMessages(i18n: any, locale: string) {
//     // load locale messages with dynamic import
//     const messages = await import(
//       /* webpackChunkName: "locale-[request]" */ `./i18n/${locale}.json`
//     )

//     // set locale and locale message
//     i18n.global.setLocaleMessage(locale, messages.default)

//     return nextTick()
// }
